import { render } from "./item_strip_stats.vue?vue&type=template&id=331819dd&scoped=true"
import script from "./item_strip_stats.vue?vue&type=script&lang=js"
export * from "./item_strip_stats.vue?vue&type=script&lang=js"

import "./item_strip_stats.vue?vue&type=style&index=0&id=331819dd&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-331819dd"]])

export default __exports__